<template>
  <div class="table table-borderless">
    <table>
      <tbody>
        <tr>
          <td v-for="shape in ufosByShape" :key="shape.key">
            <a href @click.prevent="addShapeFilter(shape)"
            :title="shape.value"
            :class="{ selected: isSelected(shape.key) }">
            {{ shape.key }}</a>
          </td>
        </tr>
        <tr>
          <td v-for="shape in ufosByShape" :key="shape.key">{{ shape.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import d3 from '@/assets/d3';

import AnimatedBar from '@/components/AnimatedBar.vue';

export default {
  props: ['value', 'ufos'],
  data() {
    return {
      width: 300,
      height: 20,
      shapes: [
        { shape: 'disk', icon: '' },
        { shape: 'formation', icon: '' },
        { shape: 'round', icon: '' },
        { shape: 'cross', icon: '' },
        { shape: 'crescent', icon: '' },
        { shape: 'rectangle', icon: '' },
        { shape: '', icon: '' },
        { shape: 'pyramid', icon: '' },
        { shape: 'hexagon', icon: '' },
        { shape: 'cylinder', icon: '' },
        { shape: 'other', icon: '' },
        { shape: 'flare', icon: '' },
        { shape: 'unknown', icon: '' },
        { shape: 'diamond', icon: '' },
        { shape: 'flash', icon: '' },
        { shape: 'cigar', icon: '' },
        { shape: 'delta', icon: '' },
        { shape: 'sphere', icon: '' },
        { shape: 'changed', icon: '' },
        { shape: 'changing', icon: '' },
        { shape: 'circle', icon: '' },
        { shape: 'dome', icon: '' },
        { shape: 'triangle', icon: '' },
        { shape: 'oval', icon: '' },
        { shape: 'teardrop', icon: '' },
        { shape: 'chevron', icon: '' },
        { shape: 'egg', icon: '' },
        { shape: 'cone', icon: '' },
        { shape: 'light', icon: '' },
        { shape: 'fireball', icon: '' },
      ],
    };
  },
  computed: {
    ufosByShape() {
      return d3.nest()
        .key(d => d.properties.shape)
        .rollup(d => d.length)
        .entries(this.ufos)
        .sort((a, b) => b.value - a.value)
        .slice(0, 5);
    },
    x() {
      return d3.scaleLinear()
        .range([0, this.width])
        .domain([0, Math.max(...this.ufosByShape.map(d => d.value))]);
    },
  },
  methods: {
    addShapeFilter(d) {
      const filters = { ...this.value };
      if (filters.shape.includes(d.key)) {
        const index = filters.shape.indexOf(d.key);
        filters.shape.splice(index, 1);
      } else {
        filters.shape = [...filters.shape, d.key]
          .sort((a, b) => a - b);
      }
      this.$emit('input', filters);
    },
    isSelected(shape) {
      return this.value.shape.includes(shape);
    },
  },
  components: {
    AnimatedBar,
  },
};
</script>

<style scoped>
  table {
    width: 100%;
    margin: 0px auto;
    font-size: 12px;
    border: 1px solid darkgrey;
    padding: 10px;
    background-color: lightgreen;
  }
  tr {
    margin: 0px;
    padding: 0px;
  }
  td {
    width: 20%;
    padding: 5px;
    color: black;
  }
  a.selected {
    background-color: darkorange !important;
  }
</style>
